<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Vendor"
    hide-footer
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Vendor</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.name"
          placeholder="Name"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormTextarea
          type="text"
          v-model="vendorForm.address"
          placeholder="Address"
        ></BFormTextarea>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.city"
          placeholder="City"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.phone"
          placeholder="Phone"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="email"
          v-model="vendorForm.email"
          placeholder="Email"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormTextarea
          type="text"
          v-model="vendorForm.description"
          placeholder="Description"
        ></BFormTextarea>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.pic_name"
          placeholder="PIC Name"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.pic_phone"
          placeholder="PIC Phone"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="email"
          v-model="vendorForm.pic_email"
          placeholder="PIC Email"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="vendorForm.status"
          placeholder="Status"
        ></BFormInput>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="handleAction" class="mr-2">{{
          vendorData && vendorData.uuid ? "Update" : "Save"
        }}</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import {
  BModal,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
} from "bootstrap-vue-next";
import { ref, inject, watch } from "vue";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BModal,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    ToastResponse,
  },
  props: {
    modal: Boolean,
    vendorData: Object,
  },
  emits: ["update:modal"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const vendorRepository = repositories ? repositories.vendor : null;

    const vendorForm = ref({
      name: "",
      description: "",
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const handleAction = () => {
      props.vendorData.uuid ? update() : create();
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const create = async () => {
      await vendorRepository
        .create(vendorForm.value)
        .then(() => {
          updateModal(false);
          vendorForm.value = {};
          modalResponse.value = {
            toast: true,
            text: "Vendor created successfully!",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        });
    };

    const update = async () => {
      await vendorRepository
        .update(vendorForm.value, props.vendorData.uuid)
        .then(() => {
          updateModal(false);
          vendorForm.value = {};
          modalResponse.value = {
            toast: true,
            text: "Vendor created successfully!",
            success: true,
          };
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        });
    };

    watch(
      () => props.vendorData,
      (newData) => {
        if (newData) {
          vendorForm.value = { ...newData };
        }
      },
      { immediate: true }
    );

    return {
      vendorForm,
      updateModal,
      handleAction,
      modalResponse,
      create,
      update,
    };
  },
};
</script>
